import { ErrorBaseData } from '.'

export const lmeAttachmentErrors: Record<string, ErrorBaseData> = {
  LmeAttachmentNotFoundException: {
    message: 'Anexo LME não encontrado',
    description: 'Não foi possível encontrar o anexo LME. Verifique as informações e tente novamente',
  },
  LmeAttachmentAlreadyExistsException: {
    message: 'Anexo LME já existe',
    description: 'Já existe um anexo LME com esse nome para esse estado',
  },
}
